var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "inspectOrder-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 75,
            model: _vm.edit,
            elem: _vm.editElem,
            rules: _vm.editRule,
            submit: false,
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "姓名", prop: "name" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入姓名",
                              disabled: _vm.readonly,
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "name", $$v)
                              },
                              expression: "edit.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "出生日期", prop: "birthday" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入出生日期",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.edit.birthday,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "birthday", $$v)
                              },
                              expression: "edit.birthday",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "学校", prop: "schoolName" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入学校",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.edit.schoolName,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "schoolName", $$v)
                              },
                              expression: "edit.schoolName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "年级", prop: "gradeName" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入年级",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.edit.gradeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "gradeName", $$v)
                              },
                              expression: "edit.gradeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "班级", prop: "classesName" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入班级",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.edit.classesName,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "classesName", $$v)
                              },
                              expression: "edit.classesName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "手机号码", prop: "phone" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入手机号码",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.edit.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "phone", $$v)
                              },
                              expression: "edit.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "条形码", prop: "barCode" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入条形码",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.edit.barCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "barCode", $$v)
                              },
                              expression: "edit.barCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "inspectStatus" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: _vm.readonly },
                              model: {
                                value: _vm.edit.inspectStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "inspectStatus", $$v)
                                },
                                expression: "edit.inspectStatus",
                              },
                            },
                            _vm._l(
                              _vm.enums.inspectStatusList,
                              function (item) {
                                return _c(
                                  "Option",
                                  {
                                    key: item.value,
                                    attrs: { value: item.value },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "创建时间", prop: "createTime" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入创建时间",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.edit.createTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "createTime", $$v)
                              },
                              expression: "edit.createTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "创建人", prop: "operator" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入操作人",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.edit.operator,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "operator", $$v)
                              },
                              expression: "edit.operator",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "14px",
                    "margin-bottom": "10px",
                    position: "relative",
                    display: "flex",
                    "border-bottom": "1px solid #DCDFE6",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        padding: "5px 16px 4px",
                        border: "1px solid #dcdee2",
                        "border-bottom": "0",
                        "border-radius": "4px 4px 0 0",
                        transition: "all .3s ease-in-out",
                        color: "#2d8cf0",
                      },
                    },
                    [_vm._v("LIS项目")]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        padding: "5px 16px 4px",
                        border: "1px solid #dcdee2",
                        "border-bottom": "0",
                        "border-radius": "4px 4px 0 0",
                        transition: "all .3s ease-in-out",
                        color: "#2d8cf0",
                        position: "absolute",
                        right: "20%",
                      },
                    },
                    [_vm._v("是否拉取")]
                  ),
                ]
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        {
                          staticStyle: {
                            "max-height": "250px",
                            "overflow-y": "auto",
                            "text-align": "left",
                          },
                          attrs: { "label-width": 0, prop: "fieldIds" },
                        },
                        [
                          _c("el-tree", {
                            ref: "lisProjectTree",
                            staticStyle: { "margin-left": "0px" },
                            attrs: {
                              data: _vm.edit.lisProjects,
                              props: _vm.defaultProps,
                              "node-key": "id",
                              "show-checkbox": "",
                              "check-strictly": true,
                              "highlight-current": true,
                              "expand-on-click-node": false,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ node, data }) {
                                  return _c(
                                    "span",
                                    { staticClass: "custom-tree-node" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-tree-node-content",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(node.label) +
                                              "\n                  "
                                          ),
                                          data.pid == 0 && data.bloodTubeId
                                            ? _c(
                                                "span",
                                                {
                                                  style: {
                                                    color: _vm.convertBloodTube(
                                                      data.bloodTubeId
                                                    ).color,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "-" +
                                                      _vm._s(data.bloodTubeName)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.edit.checkStatus > 1
                                            ? _c(
                                                "span",
                                                {
                                                  style: {
                                                    "margin-left": "30px",
                                                    color:
                                                      data.checkStatus == 1
                                                        ? "#CE1616"
                                                        : "#2d8cf0",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      data.checkStatus == 1
                                                        ? "未抽血"
                                                        : "已抽血"
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          data.checkStatus > 1 &&
                                          data.leaveStatus == 2
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#CE1616",
                                                    "margin-left": "30px",
                                                  },
                                                },
                                                [_vm._v("请假")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }